import { z } from 'zod'
import {
  normalizeIdentity,
  formalIdentityShape,
} from '../common/identity-schema.js'

export const createHrUserSchema = z
  .object({
    email: z.string().trim().min(1, 'Enter an email address.'),
    ...formalIdentityShape,
    cohortIds: z.array(z.string()),
    hrAllCohortAccess: z.boolean(),
  })
  .transform(normalizeIdentity)

export const editHrUserSchema = z
  .object({
    ...formalIdentityShape,
    cohortIds: z.array(z.string()),
    hrAllCohortAccess: z.boolean(),
  })
  .transform(normalizeIdentity)

export type CreateHrUserForm = z.infer<typeof createHrUserSchema>
export type EditHrUserForm = z.infer<typeof editHrUserSchema>
